"use client";

import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import type React from "react";
import { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Chip,
  Button,
  Card,
  CardContent,
  Box,
  LinearProgress,
  Avatar,
  CircularProgress,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Collapse,
  Pagination,
  Grid,
  alpha,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DescriptionIcon from "@mui/icons-material/Description";
import QuizIcon from "@mui/icons-material/Quiz";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";
import StarIcon from "@mui/icons-material/Star";
import { baseUrl, config, requestID } from "../../common/utils";
import axios from "axios";
import { useLocation } from "react-router";
import { arrowBack } from "ionicons/icons";
import PdfViewer from "./PdfViewer";

// Sample course data (replace with API)

const ViewEnrolledCourse: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const data = location.state?.course || {};
  console.log({ data })
  const theme = useTheme();

  const [status, setStatus] = useState({
    loading: false,
    error: false,
    errorMessage: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [courseData, setCourseData] = useState([]);
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(3); // Number of sections per page

  useEffect(() => {
    getAllModule();
    // getActivityCompletionData(data.cosID);
  }, []);

  const getAllModule = async () => {
    setStatus({ loading: true, error: false, errorMessage: "" });

    try {
      // if (!data.cosID) throw new Error("Course ID is missing");

      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("cosID", data.cosID.toString());

      const response = await axios.post(
        baseUrl() + "courses/getFullCourseStructureByCosID",
        formData,
        config
      );

      console.log({ response })

      setCourseData(response.data.data || []);
      console.log("module", response.data.data || []);
      setStatus({ loading: false, error: false, errorMessage: "" });
    } catch (error: any) {
      console.error("API call failed:", error);
      setStatus({
        loading: false,
        error: true,
        errorMessage: error.message || "Failed to fetch course data",
      });
    }
  };

  const handleToggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx); // toggle open/close
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Calculate pagination details
  const sections = courseData[0]?.sections || data.sections;
  const totalPages = Math.ceil(sections?.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentSections = sections?.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <IonPage>
      {/* Header */}
      <IonHeader>
        <IonToolbar
          style={{
            "--background": "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          }}
        >
          {/* Back button on the left */}
          <IonButtons slot="start">
            <IonBackButton
              icon={arrowBack}
              text="Go Back"
              className="back-button"
              style={{ fontWeight: 600, color: "white" }}
            />
          </IonButtons>

          {/* Center title */}
          {/* <IonTitle
            style={{
              fontWeight: 600,
              color: "white",
              textAlign: "center",
            }}
          >
            All Courses
          </IonTitle> */}
        </IonToolbar>

        <style>
          {`
            .back-button {
              border: 1px solid rgba(255,255,255,0.3);
              color: white !important;
              border-radius: 8px;
              margin-left: 10px;
              transition: all 0.3s ease;
            }
      
            .back-button:hover {
              border: 1px solid white;
              background: rgba(255,255,255,0.1);
            }
      
            ion-title {
              width: 100%;
              justify-content: center;
            }
          `}
        </style>
      </IonHeader>

      {/* Content */}
      <IonContent fullscreen style={{ "--background": "#f7f9fa" }}>
        <Box sx={{ maxWidth: 1200, mx: "auto", p: 3 }}>
          {/* Course Header Card */}
          <Box
            elevation={0}
            sx={{
              mb: 4,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              borderRadius: 3,
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
            }}
          >
            <CardContent sx={{ p: 4 }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <Avatar
                  sx={{
                    bgcolor: "rgba(255,255,255,0.2)",
                    mr: 2,
                    width: 56,
                    height: 56,
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <PersonIcon sx={{ fontSize: 32 }} />
                </Avatar>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="h4" fontWeight="bold" sx={{ mb: 1 }}>
                    {courseData[0]?.name || data.name}
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 3,
                      mb: 2,
                      flexWrap: "wrap",
                    }}
                  >
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      <DescriptionIcon sx={{ fontSize: 20 }} />
                      <Typography variant="body2">
                        {sections?.length} sections
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Typography
                variant="body1"
                sx={{ mb: 3, opacity: 0.9, lineHeight: 1.6 }}
              >
                {courseData[0]?.description || data.description}
              </Typography>
            </CardContent>
          </Box>

          {/* Course Content Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <Typography
              variant="h5"
              fontWeight="bold"
              sx={{ color: "#1c1d1f" }}
            >
              Course Module
            </Typography>

            <Chip
              label={`Page ${currentPage} of ${totalPages}`}
              variant="outlined"
              sx={{
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                borderColor: theme.palette.primary.main,
                color: theme.palette.primary.dark,
                fontWeight: 500,
              }}
            />
          </Box>

          {/* Sections */}
          {currentSections?.map((section, sectionIndex) => (
            <Card
              key={section.secID}
              elevation={0}
              sx={{
                mb: 3,
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                overflow: "hidden",
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 20px rgba(0, 0, 0, 0.1)",
                },
              }}
            >
              <Accordion
                elevation={0}
                sx={{
                  "&:before": { display: "none" },
                  "& .MuiAccordionSummary-root": {
                    backgroundColor: "#f8f9fa",
                    borderBottom: "1px solid #e0e0e0",
                    minHeight: 64,
                    "&:hover": {
                      backgroundColor: "#f0f0f0",
                    },
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  sx={{ px: 3 }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Box
                      sx={{ display: "flex", alignItems: "center", flex: 1 }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: 32,
                          height: 32,
                          borderRadius: "50%",
                          backgroundColor: theme.palette.primary.main,
                          color: "white",
                          mr: 2,
                          fontWeight: "bold",
                        }}
                      >
                        {indexOfFirstItem + sectionIndex + 1}
                      </Box>
                      <Typography variant="h6" fontWeight="600">
                        {section.name}
                      </Typography>
                    </Box>
                    <Chip
                      label={`${section.lessons?.length || 0} lessons`}
                      size="small"
                      sx={{
                        backgroundColor: "#e3f2fd",
                        color: "#1976d2",
                        fontWeight: 500,
                      }}
                    />
                  </Box>
                </AccordionSummary>

                <AccordionDetails sx={{ p: 0 }}>
                  {section.lessons && section.lessons.length > 0 ? (
                    <List sx={{ py: 0 }}>
                      {section.lessons.map((lesson, lessonIndex) => (
                        <Box key={lesson.lessonID}>
                          {/* Lesson Header */}
                          <ListItem
                            sx={{
                              py: 2,
                              px: 3,
                              backgroundColor: "#fafafa",
                              borderBottom: "1px solid #f0f0f0",
                            }}
                          >
                            <ListItemIcon>
                              <PlayCircleOutlineIcon
                                sx={{ color: "#1976d2", fontSize: 28 }}
                              />
                            </ListItemIcon>
                            <ListItemText
                              primary={
                                <Typography
                                  variant="subtitle1"
                                  fontWeight="600"
                                >
                                  {lessonIndex + 1}. {lesson.name}
                                </Typography>
                              }
                              secondary={
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Created:{" "}
                                  {new Date(
                                    lesson.dateCreated
                                  ).toLocaleDateString()}
                                </Typography>
                              }
                            />
                            <CheckCircleIcon sx={{ color: "#4caf50", ml: 2 }} />
                          </ListItem>

                          {/* Lesson Files */}
                          {lesson.lessonFiles &&
                            lesson.lessonFiles.length > 0 && (
                              <Box sx={{ pl: 7, pr: 3, pb: 2 }}>
                                {lesson.lessonFiles.map((file, idx) => (
                                  <Box
                                    key={idx}
                                    sx={{
                                      mb: 2,
                                      borderRadius: 2,
                                      overflow: "hidden",
                                      border: "1px solid #e0e0e0",
                                      backgroundColor: "#fff",
                                    }}
                                  >
                                    {/* File Row */}
                                    <ListItem
                                      component="button"
                                      onClick={() => handleToggle(idx)}
                                      sx={{
                                        py: 1,
                                        px: 2,
                                        textAlign: "left",
                                        color: "inherit",
                                        width: "100%",
                                        "&:hover": {
                                          backgroundColor: "#f5f5f5",
                                          borderColor: "#1976d2",
                                        },
                                      }}
                                    >
                                      <ListItemIcon sx={{ minWidth: 40 }}>
                                        <DescriptionIcon
                                          sx={{
                                            color: "#ff6b35",
                                            fontSize: 20,
                                          }}
                                        />
                                      </ListItemIcon>
                                      <ListItemText
                                        primary={
                                          <Typography
                                            variant="body2"
                                            fontWeight="500"
                                          >
                                            {file.name}
                                          </Typography>
                                        }
                                      />
                                      <Chip
                                        label="PDF"
                                        size="small"
                                        sx={{
                                          backgroundColor: "#fff3e0",
                                          color: "#f57c00",
                                          fontSize: "0.75rem",
                                        }}
                                      />
                                    </ListItem>

                                    {/* Expandable PDF Viewer */}
                                    <Collapse
                                      in={openIndex === idx}
                                      timeout="auto"
                                      unmountOnExit
                                    >
                                      <Box
                                        sx={{
                                          p: 2,
                                          borderTop: "1px solid #e0e0e0",
                                          backgroundColor: "#fafafa",
                                        }}
                                      >
                                        {file.classFile}
                                        <iframe
                                          src={`https://${file.classFile}`}
                                          width="100%"
                                          height="800px"
                                          style={{ border: "none" }}
                                          title={`PDF-${idx}`}
                                        />
                                      </Box>
                                    </Collapse>
                                  </Box>
                                ))}
                              </Box>
                            )}

                          {/* Lesson Quizzes */}
                          {lesson.quizzes && lesson.quizzes.length > 0 && (
                            <Box sx={{ pl: 7, pr: 3, pb: 2 }}>
                              {lesson.quizzes.map((quiz) => (
                                <ListItem
                                  key={quiz.id}
                                  sx={{
                                    py: 2,
                                    px: 2,
                                    mb: 1,
                                    borderRadius: 2,
                                    backgroundColor: "#fff",
                                    border: "1px solid #e0e0e0",
                                  }}
                                >
                                  <ListItemIcon sx={{ minWidth: 40 }}>
                                    <QuizIcon
                                      sx={{ color: "#9c27b0", fontSize: 20 }}
                                    />
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={
                                      <Typography
                                        variant="body2"
                                        fontWeight="500"
                                      >
                                        {quiz.name}
                                      </Typography>
                                    }
                                    secondary={
                                      <Typography
                                        variant="caption"
                                        color="text.secondary"
                                      >
                                        Pass Grade: {quiz.passGrade}% • Time:{" "}
                                        {quiz.quizzTime} mins
                                      </Typography>
                                    }
                                  />
                                  <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                      backgroundColor: "#9c27b0",
                                      "&:hover": {
                                        backgroundColor: "#7b1fa2",
                                      },
                                      textTransform: "none",
                                      fontWeight: 600,
                                      px: 3,
                                      borderRadius: 2,
                                    }}
                                  >
                                    Start Quiz
                                  </Button>
                                </ListItem>
                              ))}
                            </Box>
                          )}
                        </Box>
                      ))}
                    </List>
                  ) : (
                    <Box sx={{ p: 3, textAlign: "center" }}>
                      <Typography variant="body2" color="text.secondary">
                        No lessons available in this section.
                      </Typography>
                    </Box>
                  )}
                </AccordionDetails>
              </Accordion>
            </Card>
          ))}

          {/* Pagination Controls */}
          {sections?.length > itemsPerPage && (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
                size="large"
                sx={{
                  "& .MuiPaginationItem-root": {
                    borderRadius: 2,
                    fontWeight: 500,
                  },
                  "& .Mui-selected": {
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  },
                }}
              />
            </Box>
          )}
        </Box>
      </IonContent>
    </IonPage>
  );
};

export default ViewEnrolledCourse;
